<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-ok`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.4137 4.29498C12.6734 4.03577 13.0946 4.03641 13.3541 4.29596C13.6133 4.55571 13.6127 4.97686 13.3531 5.23639L6.8844 11.7051C6.62475 11.9644 6.20357 11.9645 5.94397 11.7051L2.64514 8.40631C2.3859 8.14669 2.38589 7.72549 2.64514 7.46588C2.90473 7.20643 3.32589 7.20658 3.58557 7.46588L6.41467 10.294L12.4137 4.29498Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineOk',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
